import { PlayerSizesTypes } from '../../../../common/store/store.types';
import { SITE_VARIABLES } from '../../../../common/styles/variables';
import { isEmpty } from '../../../../common/utils/utils';

interface StylesObject {
  titleStyle: { [key: string]: any };
  titleAndToolTipContainerStyle: { [key: string]: any };
}

const titleFontFamily = SITE_VARIABLES.TEXT_FONT_FAMILY.LATO;
const titleColor = SITE_VARIABLES.COLORS.WHITE;
const titleFontWeight = '300';

const title = {
  fontFamily: titleFontFamily,
  fontWeight: titleFontWeight,
  color: titleColor,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  display: 'block',
  small: {
    display: 'none',
  },
  medium: {
    fontSize: SITE_VARIABLES.FONT_SIZE.SMALL,
    onlyTitle: {
      margin: '0px 48px 0px 8px',
    },
    titleWithLogo: {
      margin: '0px 20px 0px 8px',
    },
    titleWithLogoAndIcon: {
      margin: '0px 4px 0px 8px',
    },
    titleWithIcon: {
      margin: '0px 4px 0px 8px',
    },
  },
  large: {
    fontSize: SITE_VARIABLES.FONT_SIZE.SMALL,
    onlyTitle: {
      margin: '0px 42px 0px 8px',
    },
    titleWithLogo: {
      margin: '0px 42px 0px 8px',
    },
    titleWithLogoAndIcon: {
      margin: '0px 22px 0px 8px',
    },
    titleWithIcon: {
      margin: '0px 18px 0px 8px',
    },
  },
  extraLarge: {
    fontSize: SITE_VARIABLES.FONT_SIZE.MEDIUM,
    onlyTitle: {
      margin: '0px 52px 0px 16px',
    },
    titleWithLogo: {
      margin: '0px 52px 0px 8px',
    },
    titleWithLogoAndIcon: {
      margin: '0px 16px 0px 8px',
    },
    titleWithIcon: {
      margin: '0px 16px',
    },
  },
  splitView: {
    display: 'none',
  },
  anchor: {
    display: 'none',
  },
};

const titleAndToolTipContainer = {
  width: '100%',
  position: 'relative',
  display: 'grid',
};

export const getTitleStyleObject = (showLogo: boolean, showShareIcon: boolean, playerSize: PlayerSizesTypes,
  splitViewRatio: number, closableAnchor: boolean): StylesObject => {
  const showIcon = showShareIcon;
  const smallSize = playerSize === 'small';
  const mediumSize = playerSize === 'medium';
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';
  const splitView = !isEmpty(splitViewRatio);

  return ({
    titleStyle: [
      title,
      smallSize && title.small,
      splitView && title.splitView,
      closableAnchor && title.anchor,

      mediumSize && title.medium,
      mediumSize && !showLogo && !showIcon && title.medium.onlyTitle,
      mediumSize && showLogo && !showIcon && title.medium.titleWithLogo,
      mediumSize && showLogo && showIcon && title.medium.titleWithLogoAndIcon,
      mediumSize && !showLogo && showIcon && title.medium.titleWithIcon,

      largeSize && title.large,
      largeSize && !showLogo && !showIcon && title.large.onlyTitle,
      largeSize && showLogo && !showIcon && title.large.titleWithLogo,
      largeSize && showLogo && showIcon && title.large.titleWithLogoAndIcon,
      largeSize && !showLogo && showIcon && title.large.titleWithIcon,

      extraLargeSize && title.extraLarge,
      extraLargeSize && !showLogo && !showIcon && title.extraLarge.onlyTitle,
      extraLargeSize && showLogo && !showIcon && title.extraLarge.titleWithLogo,
      extraLargeSize && showLogo && showIcon && title.extraLarge.titleWithLogoAndIcon,
      extraLargeSize && !showLogo && showIcon && title.extraLarge.titleWithIcon,
    ],
    titleAndToolTipContainerStyle: {
      ...titleAndToolTipContainer,
    },
  });
};
